var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 45H40M20 45C20 50.5228 24.4772 55 30 55C35.5228 55 40 50.5228 40 45M20 45V39.4718C20 37.8373 19.1665 36.3408 17.9788 35.2178C14.605 32.0277 12.5 27.5097 12.5 22.5C12.5 12.835 20.335 5 30 5C39.665 5 47.5 12.835 47.5 22.5C47.5 27.5097 45.395 32.0277 42.0212 35.2178C40.8335 36.3408 40 37.8373 40 39.4718V45M25 22.5L30 27.5M30 27.5L35 22.5M30 27.5V45",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.8ed23e6aab6a6576e53c6b654f9a03b0.svg";
export { ForwardRef as ReactComponent };